import { react2angular } from 'react18-react2angular';

export function makeNgComponent(name: string, reactComponent: any, props?: string[], services?: string[]) {
    if (!props && !services) {
        if (!reactComponent.propTypes) {
            throw new Error(`Can't convert component ${name}: should provide any of: props, services or PropTypes.`);
        }
    }

    getAngularRootModule().component(name, react2angular(reactComponent, props, services));
}

const ROOT_ANGULAR_MODULE_NAME = 'z.react-modules';

function getAngularRootModule() {
    try {
        return window.angular.module(ROOT_ANGULAR_MODULE_NAME);
    } catch {
        return window.angular.module(ROOT_ANGULAR_MODULE_NAME, []);
    }
}

const ngReadyPromise = new Promise((resolve) => {
    getAngularRootModule().run(() => {
        resolve(true);
    });
});

export function onNgReady() {
    return ngReadyPromise;
}
